import i18next from "i18next";

import { GameLocalizedFields } from "../types/gamePack";
import { DEFAULT_LANGUAGE } from "./language";

export const isText = (value: unknown): value is string =>
  typeof value === "string" && value.trim() !== "";

export const isFilled = <T>(value: T | undefined | null): value is T =>
  value !== undefined &&
  value !== null &&
  (typeof value !== "string" || isText(value));

export const getByLanguage = <T>(
  field: Record<string, T> | undefined | null,
  language?: string,
): T | undefined => {
  const value = field?.[language || DEFAULT_LANGUAGE];
  return isFilled(value) ? value : field?.[DEFAULT_LANGUAGE];
};

type LocalizedSource = Record<string, unknown> & {
  translations?: Record<string, GameLocalizedFields>;
};

const parseIfJsonObject = (value: unknown): unknown => {
  if (typeof value !== "string" || !value.trim().startsWith("{")) return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

export const getLocalizedField = (
  source: LocalizedSource | null | undefined,
  field: keyof GameLocalizedFields,
  language?: string | null,
): string | undefined => {
  if (!source) return undefined;

  const value = parseIfJsonObject(source[field]);
  const byCode = value as Record<string, unknown> | undefined;
  const lng = language || i18next.language || DEFAULT_LANGUAGE;

  const candidates = [lng, DEFAULT_LANGUAGE].flatMap((code) => [
    source.translations?.[code]?.[field],
    byCode?.[code],
  ]);

  return [...candidates, value].find(isText);
};
